import React, { useEffect, useState } from 'react'
import {
  PlayerListContainer,
  LoadingContainer,
  PlayerBoardCon
} from './styles'
import { PlayerCard } from './PlayerCard'
import { useDraftContext } from '../../../Context/DraftContext/DraftContext'
import { PageContentLoading } from '../../../Components/Loading/PageContentLoading'
import { PositionFilters } from '../../../Components/Layout/Selectors/Position/PositionFilters'
import { DraftPlayer } from '../../../Api'
import { ListAnimation } from '../../../Components/Animations/ListAnimations'

export const PlayerList: React.FC = () => {
  const { availablePlayers, currentYearDraftPicks, isLoading } = useDraftContext()
  const [position, setPosition] = useState<string>('All')
  const [playerList, setPlayerList] = useState<DraftPlayer[]>([])
  const [filteredPlayers, setFilteredPlayers] = useState<DraftPlayer[]>([])
  const isDraftBoardPage = window && window.location.pathname === '/draft/board'

  useEffect(() => {
    //Do not filter out picks if on draft board page
    if (currentYearDraftPicks.length < 1 || isDraftBoardPage) {
      setPlayerList(availablePlayers)
      setFilteredPlayers(availablePlayers)
      return
    }
    if (!isDraftBoardPage) {
      const filteredPlayers = filterOutDraftedPlayers(availablePlayers)
      setPlayerList(filteredPlayers)
      setFilteredPlayers(filteredPlayers)
      return
    }

    setPlayerList(availablePlayers)
    setFilteredPlayers(availablePlayers)
  }, [availablePlayers, currentYearDraftPicks])

  const onChangePosition = (changedPosition: string) => {
    setPosition(changedPosition)

    const filtered = filterPlayersByPosition(playerList, changedPosition)

    setFilteredPlayers(filtered)
  }

  const filterPlayersByPosition = (
    players: DraftPlayer[],
    selectedPosition: string
  ): DraftPlayer[] => {
    if (selectedPosition === 'All') {
      return playerList
    }
    return players.filter((player) => selectedPosition === player?.position)
  }

  const filterOutDraftedPlayers = (players: DraftPlayer[]) => {
    return players.filter(
      (player) =>
        !currentYearDraftPicks.some((pick) => pick.playerName === player.playerName)
    )
  }

  if (isLoading) {
    return (
      <LoadingContainer>
        <PageContentLoading />
      </LoadingContainer>
    )
  }

  if (!availablePlayers || availablePlayers.length === 0) {
    return <div>No available players</div>
  }

  return (
    <PlayerBoardCon fullHeight={isDraftBoardPage}>
      <PositionFilters current={position} onChangePosition={onChangePosition} />
      <PlayerListContainer fullHeight={isDraftBoardPage}>
        {filteredPlayers.length > 0 &&
          filteredPlayers.map((player, index) => (
            <ListAnimation
              key={player.id}
              index={index}
              stagger={50}
              duration={300}
            >
              <PlayerCard player={player} />
            </ListAnimation>
          ))}
        {filteredPlayers.length === 0 && <div>No available players</div>}
      </PlayerListContainer>
    </PlayerBoardCon>
  )
}
